import type { RequestPresign, UploadedFile, UploadKind } from './types'

let requestPresign: RequestPresign | null = null

export function setFileUploader(presign: RequestPresign) {
  requestPresign = presign
}

function getRequestPresign(): RequestPresign {
  if (!requestPresign) {
    throw new Error('File uploader is not configured. Call setFileUploader() from the app.')
  }
  return requestPresign
}

export async function uploadFilesToStorage(
  kind: UploadKind,
  files: File[]
): Promise<UploadedFile[]> {
  const presign = getRequestPresign()
  const uploaded: UploadedFile[] = []

  for (const file of files) {
    const { uploadUrl, publicUrl, key } = await presign({
      kind,
      fileName: file.name,
      contentType: file.type || 'application/octet-stream',
      size: file.size
    })

    const response = await fetch(uploadUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type || 'application/octet-stream'
      }
    })

    if (!response.ok) {
      throw new Error(`Upload failed (${response.status})`)
    }

    uploaded.push({
      key,
      name: file.name,
      url: publicUrl,
      size: file.size,
      type: file.type || 'application/octet-stream'
    })
  }

  return uploaded
}
